const tableSchema = {
  UNIT: 'unit',
  RATIO_NAME: 'ratioName',
}

export const getCellStyleByColId = (colId) => {
  if (colId === tableSchema.UNIT || colId === tableSchema.RATIO_NAME) return {}

  return {
    thStyle: { justifyContent: 'flex-end' },
    tdStyle: { textAlign: 'right' },
  }
}
